const tabs = {
  personalInfoTab: 'personal-info-tab',
  sensitiveInfoTab: 'sensitive-info-tab',
  professionalInfoTab: 'professional-info-tab',
  contactInfoTab: 'contact-info-tab',
  sectionPicker: 'profile-section-picker',
};

export default tabs;
